<template>
  <base-new-form>
    <template v-slot:header>
      {{ $t('renew_change_policy_header') }}
    </template>
    <div class="car-policy-info">
      <RenewInformation
        :productName="carProductName"
        :productType="productType"
        :policyNumber="carInfo.policyNumber"
        :productTitle="productTitle"
        :endPolicyDate="endPolicyDate">
        <template v-slot:info>
          <li class="quote__info-list_bottom-count">
            <span>{{ $t('renew_car_info_seats') }}: {{ carInfo.seats }}</span>
            <span>{{ $t('renew_car_info_cylinders') }}: {{ carInfo.cylinders }}</span>
          </li>
          <li>{{ $t('renew_car_info_chassis') }}: {{ carInfo.chassis }}</li>
        </template>
      </RenewInformation>
      <Promo3MFF v-if="isCampaignPromoCodeApplied" />
      <MotorChangeTplForm
        v-if="isTpl"
        :switchValue="tplChangeSwitcher"
        :tplInfo="{ price: tplPriceFrom, discount: tplMinDiscount, monthlyPrice: tplMonthlyPrice }"
        :odInfo="{ price: odPriceFrom, discount: odMinDiscount, monthlyPrice: odMonthlyPrice }"
        :odSchemes="odSchemes"
        :offer-text="promoCampaignText"
        :tplSchemes="tplSchemes"
        @switchPlan="switchPlan"
        @clickLearnMore="clickLearnMore"
        @submit="onUpgradeSubmit"/>
      <template v-if="isOd">
        <MotorChangeNoOdSchemesForm
          v-if="!isOdRenewal"
          :switchValue="tplChangeSwitcher"
          :priceFromForTplPlan="tplPriceFrom"
          :productTitle="productTitleForForm"
          @submit="onSubmit(tplSchemes[0])"/>
        <MotorOdPlanForm
          v-else-if="odSchemes.length === 1"
          :includes="allOdIncludes"
          :priceFrom="odPriceFrom"
          :installmentPrice="odMonthlyPrice"
          :minDiscount="odMinDiscount"
          :discount="odDiscount"
          @submit="onSubmit(odSchemes[0])"/>
        <MotorChangeSelectPlan
          v-else
          :schemes="odSchemesSorted"
          :productType="productType"
          :policyInfo="policyInfo"
          @submit="onSubmit"/>
      </template>
    </div>
    <template v-if="isOd && isOdRenewal && isTPLDowngradePossible">
      <div class="or">
        <span>{{ $t('renew_change_policy_or') }}</span>
      </div>
      <BaseButton class="btn-second" symbol="no" @click.prevent="onOpenTplPoup">{{ $t('renew_change_policy_tpl_only') }}</BaseButton>
    </template>
    <BasePopupWrapper v-if="showTplPopup" @close="onCloseTplPopup" >
      <CarDowngradeToTplPopup @select="onDowngrade"/>
      <template v-slot:button>
        <a href="#" class="btn btn_medium" @click.prevent="onCloseTplPopup">
          {{ $t('renew_change_policy_tpl_popup_cancel') }}
        </a>
      </template>
    </BasePopupWrapper>
  </base-new-form>
</template>

<script>
import { BaseNewForm, BasePopupWrapper, RenewInformation, wizardStepMixin } from 'qic-components'
import CarDowngradeToTplPopup from '@/components/CarDowngradeToTplPopup'
import MotorChangeTplForm from '@/components/renewMotor/MotorChangeTplForm'
import MotorOdPlanForm from '@/components/renewMotor/MotorOdPlanForm'
import MotorChangeSelectPlan from '@/components/renewMotor/MotorChangeSelectPlan'
import MotorChangeNoOdSchemesForm from '@/components/renewMotor/MotorChangeNoOdSchemesForm'
import { trackGtag } from '@/utils/useGtag'
import Promo3MFF from '@/components/campaigns/Promo3MFF.vue'
import { mapState } from 'vuex'
import { MONTH_PAYMENT_EXPERIMENT } from '@/constants/experimentNames'
import { OD_CODE, TPL_CODE } from '@/constants/constants.ts'
import analyticsDataMixin from '@/mixins/analyticsDataMixin'

export default {
  name: 'CarChangePlan',
  mixins: [
    wizardStepMixin,
    analyticsDataMixin
  ],
  data () {
    return {
      tplChangeSwitcher: 'tpl',
      showTplPopup: false,
      allOdIncludes: [],
      odSchemes: [],
      tplSchemes: [],
      odPriceFrom: 1400,
      odMonthlyPrice: 0,
      tplPriceFrom: 0,
      tplMonthlyPrice: 0,
      odMinDiscount: 0,
      minOdIncludes: [],
      odDiscount: 0,
      tplMinDiscount: 0,
      chosenPlan: 'tpl'
    }
  },
  components: {
    Promo3MFF,
    RenewInformation,
    BaseNewForm,
    CarDowngradeToTplPopup,
    BasePopupWrapper,
    MotorChangeTplForm,
    MotorOdPlanForm,
    MotorChangeSelectPlan,
    MotorChangeNoOdSchemesForm
  },
  computed: {
    ...mapState({
      isCampaignPromoCodeApplied: state => state.motor.isCampaignPromoCodeApplied
    }),
    promoCampaignText () {
      return this.isCampaignPromoCodeApplied ? this.$t('renew.upgrade.label.3mff_campaign') : ''
    },
    productType () {
      return this.$store.state.renew.productType
    },
    policyInfo () {
      return this.$store.state.renew.policyInfo
    },
    carProductName () {
      if (!this.policyInfo) return ''
      if (this.productType === 'moto') return this.$t('renew_moto_insurance')
      return this.policyInfo.prodCode === OD_CODE ? this.$t('renew_car_comprehensive') : this.$t('renew_car_tpl')
    },
    carInfo () {
      if (!this.policyInfo) return {}
      return {
        makeModel: this.policyInfo.makeModel,
        modelYear: this.policyInfo.modelYear,
        policyNumber: this.policyInfo.policyNo,
        chassis: this.policyInfo.chassisNo,
        cylinders: this.policyInfo.noOfCylinder,
        seats: this.policyInfo.seatingCapacity,
        plateNumber: this.policyInfo.regNo
      }
    },
    userInfo () {
      if (!this.policyInfo) return {}
      return {
        fullName: this.policyInfo.insName,
        qid: this.policyInfo.civilId,
        mobileNumber: this.policyInfo.mobileNo,
        email: this.policyInfo.emailId
      }
    },
    productTitle () {
      return `${this.carInfo.makeModel} ${this.carInfo.modelYear}`
    },
    productTitleForForm () {
      return `${this.carInfo.makeModel}, ${this.carInfo.modelYear}`
    },
    endPolicyDate () {
      if (!this.policyInfo) return new Date()
      return this.policyInfo.polEndDate && new Date(this.policyInfo.polEndDate)
    },
    isTpl () {
      if (!this.policyInfo) return false
      return this.policyInfo.prodCode === TPL_CODE
    },
    isTPLDowngradePossible () {
      return Boolean(this.tplSchemes[0])
    },
    isOd () {
      return !this.isTpl
    },
    isOdRenewal () {
      return !!this.odSchemes.length
    },
    locale () {
      return this.$i18n.locale
    },
    chosenTpl () {
      return this.chosenPlan === 'tpl'
    },
    trackInfo () {
      const planName = this.isOd ? 'OD' : 'TPL'
      const planNames = ['TPL', 'Comprehensive']
      const chosenPlanName = this.chosenTpl ? planNames[0] : planNames[1]
      const isMonthlyPayment = this.$store.state.typeOfPayment === MONTH_PAYMENT_EXPERIMENT
      const paymentType = isMonthlyPayment ? 'monthly' : 'total'
      const odPrice = isMonthlyPayment ? this.odMonthlyPrice : this.odPriceFrom
      const currentPrice = this.chosenTpl ? this.tplPriceFrom : odPrice

      return {
        odPrice,
        planName,
        currentPrice,
        paymentType,
        planNames,
        chosenPlanName,
        page: 'change_plan',
        product: 'renewal',
        category: 'carIns'
      }
    },
    odSchemesSorted () {
      return [...this.odSchemes].sort((a, b) => a.price - b.price)
    }
  },
  methods: {
    switchPlan (chosenPlan) {
      this.chosenPlan = chosenPlan === 'comp' ? 'od' : 'tpl'
      this.trackSelectItem()
    },
    onSubmit (scheme) {
      if (this.isOd) {
        if (!this.isOdRenewal) {
          this.$store.commit('setMotorChangePlan', { status: true, prodCode: TPL_CODE })
        } else {
          this.$store.commit('setMotorChangePlan', { status: false, prodCode: null })
        }
        this.$store.commit('setMotorRenewScheme', scheme)
      }
      this.trackSelectItem(this.isOd ? 'OD' : 'TPL')

      const params = this.getAnalyticsData()

      trackGtag('click_proceed', {
        page: 'change_plan',
        policy_id: this.policyInfo.policyNo,
        glm: this.odSchemes[0]?.glmScheme,
        chosen_plan: this.chosenPlan.toUpperCase(),
        ...params
      })
      this.$emit('next')
    },
    onUpgradeSubmit (plan) {
      const isTpl = plan === 'tpl'
      const isOd = !isTpl
      this.$store.commit('setMotorChangePlan', { status: isOd, prodCode: isTpl ? TPL_CODE : OD_CODE })
      if (isTpl) {
        this.$store.commit('setMotorRenewScheme', this.tplSchemes[0])
        this.trackProceed()
        this.$emit('next')
        return
      }
      this.trackProceed()
      this.$router.push({ name: 'WizardRenewMotor', params: { page: 'vehicle-value' } })
    },
    onDowngrade () {
      this.trackProceed()
      this.$store.commit('setMotorChangePlan', { status: true, prodCode: TPL_CODE })
      this.$store.commit('setMotorRenewScheme', this.tplSchemes[0])
      this.$emit('next')
    },
    clickLearnMore () {
      this.trackClickLearnMore()
    },
    trackClickLearnMore () {
      const { chosenPlanName, category, page, product, currentPrice } = this.trackInfo
      trackGtag('click_learn_more', {
        chosen_plan: this.chosenPlan,
        total_price: currentPrice,
        item_name: chosenPlanName,
        category,
        page,
        product
      })
    },
    trackProceed () {
      const { planName, category, page, product, currentPrice, paymentType } = this.trackInfo

      const params = this.getAnalyticsData()

      trackGtag('click_proceed', {
        policy_id: this.policyInfo.policyNo,
        chosen_plan: this.chosenPlan.toUpperCase(),
        plan_name: planName,
        total_price: currentPrice,
        flag_price: paymentType,
        category,
        page,
        product,
        glm: this.odSchemes[0]?.glmScheme,
        ...params
      })
    },
    trackSelectItem () {
      const { planName, chosenPlanName, category, page, product, currentPrice, paymentType } = this.trackInfo
      const { quoteno } = this.$store.state.motor.policySchemesInfo.info
      trackGtag('select_item', {
        product,
        category,
        page,
        policy_id: this.policyInfo.policyNo,
        quote_id: quoteno.toString(),
        plan_name: planName,
        flag_price: paymentType,
        chosen_plan: this.chosenPlan,
        item_name: chosenPlanName,
        price: currentPrice,
        glm: this.odSchemes[0]?.glmScheme
      })
    },
    trackViewItem () {
      const { planName, category, page, product, paymentType, odPrice, planNames } = this.trackInfo
      const { info } = this.$store.state.motor.policySchemesInfo

      trackGtag('view_select_plan', {
        category,
        page,
        product,
        policy_id: this.policyInfo.policyNo,
        quote_id: info.quoteno.toString(),
        plan_name: planName,
        item_name: planNames,
        flag_price: paymentType,
        price: [this.tplPriceFrom.toString(), odPrice],
        glm: this.odSchemes[0]?.glmScheme
      })
    },

    onOpenTplPoup () {
      this.showTplPopup = true
    },
    onCloseTplPopup () {
      this.showTplPopup = false
    },
    setOdInfo (schemes) {
      if (!schemes && !schemes.length) return
      this.odSchemes = schemes.filter((s) => s.productcode === OD_CODE)

      if (this.odSchemes.length) {
        this.allOdIncludes = [...this.odSchemes.reduce((acc, s) => {
          s.included.forEach(i => {
            acc.add({ name: i.name, id: i.id })
          })
          return acc
        }, new Set())]
        const getDiscount = (scheme) => {
          return scheme?.discount && scheme?.price ? Number((scheme?.discount * 100 / (scheme?.discount + scheme?.price)).toFixed(0)) : 0
        }
        if (this.odSchemes.length === 1) {
          const odScheme = this.odSchemes[0]
          this.odPriceFrom = odScheme.price
          this.odMonthlyPrice = odScheme.monthlyPrice
          this.odMinDiscount = getDiscount(odScheme)
          this.odDiscount = odScheme.discount
        } else {
          const odMinScheme = this.odSchemes.reduce((acc, next) => {
            if (acc === null) return next
            return acc.price > next.price ? next : acc
          }, null)
          this.odPriceFrom = odMinScheme.price
          this.odMonthlyPrice = odMinScheme.monthlyPrice
          this.odMinDiscount = getDiscount(odMinScheme)
        }
      }
    },
    setTplInfo (schemes) {
      if (!schemes && !schemes.length) return

      this.tplSchemes = schemes.filter((s) => s.productcode === TPL_CODE)
      if (this.tplSchemes.length) {
        this.$store.commit('setIsDowngradePossible', true)
        if (this.tplSchemes.length === 1) {
          const tplSchema = this.tplSchemes[0]
          this.tplPriceFrom = tplSchema.price
          this.tplMonthlyPrice = tplSchema.monthlyPrice
          this.tplMinDiscount = Number((tplSchema?.discount * 100 / (tplSchema?.discount + tplSchema?.price)).toFixed(0))
        } else {
          const minTplSchema = this.tplSchemes.reduce((maxSchema, currentSchema) => {
            if (currentSchema.price < maxSchema.price) {
              return currentSchema
            } else {
              return maxSchema
            }
          })
          this.tplPriceFrom = minTplSchema.price
          this.tplMonthlyPrice = minTplSchema.monthlyPrice
          this.tplMinDiscount = Number((minTplSchema?.discount * 100 / (minTplSchema?.discount + minTplSchema?.price)).toFixed(0))
        }
      }
      this.trackViewItem()
    }
  },
  created () {
    const changePlanStatus = this.$store.state.motor.changePlan.status
    if (changePlanStatus) {
      this.tplChangeSwitcher = this.isTpl ? 'comp' : 'tpl'
      return
    }
    if (this.isOd && !this.isOdRenewal) this.tplChangeSwitcher = 'comp'
  },
  async mounted () {
    this.load(
      Promise.all([
        this.$store.dispatch('getMotorRenewSchemes'),
        this.$store.dispatch('getABDistribution')
      ])
        .then(([schemes]) => {
          const quoteSchemes = schemes
          if (!quoteSchemes && !quoteSchemes.length) {
            throw new Error('No Schemes Found')
          }
          this.setOdInfo(quoteSchemes)
          this.setTplInfo(quoteSchemes)
          if (this.isTpl && !quoteSchemes.length) {
            return this.$router.push({ name: 'WizardRenewMotor', params: { page: 'quote-reference' } })
          }

          if (quoteSchemes.length === 1 && this.isTpl) {
            if (quoteSchemes[0]?.productcode === OD_CODE) {
              this.$store.commit('setMotorChangePlan', { status: true, prodCode: OD_CODE })
            }

            this.$store.commit('setMotorRenewScheme', quoteSchemes[0])
            return this.$emit('next', { replace: true })
          }
        })
    )
  }
}
</script>
